import {Component} from '@angular/core';
import { LoginInfoComponent } from '../../../shared/components/login-info/login-info.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-maintenance-mode',
    templateUrl: './maintenance-mode.component.html',
    styleUrls: ['./maintenance-mode.component.scss'],
    imports: [LoginInfoComponent, TranslatePipe],
})
export class MaintenanceModeComponent {}
